<script setup lang="ts">
import type { SelectOption } from 'naive-ui'
import type { CreateDefectLogisticsTask } from '~/types'

defineProps<{
  payload: CreateDefectLogisticsTask
  customerOptions: SelectOption[]
  isLogisticsTaskPlanned: boolean
}>()
defineEmits<{
  (e: 'submit', payload: CreateDefectLogisticsTask): void
}>()
</script>

<template>
  <FormKit
    :value="payload"
    type="form"
    :submit-label="$t('logisticsTask.createOrEdit.submit')"
    @submit="$emit('submit', $event)"
  >
    <FormKit
      name="deliveryFrom"
      type="text"
      validation="required"
      :label="$t('logisticsTask.createOrEdit.deliveryFrom.label')"
      :placeholder="$t('logisticsTask.createOrEdit.deliveryFrom.placeholder')"
    />
    <FormKit
      name="deliveryTo"
      type="text"
      validation="required"
      :label="$t('logisticsTask.createOrEdit.deliveryTo.label')"
      :placeholder="$t('logisticsTask.createOrEdit.deliveryTo.placeholder')"
    />
    <FormKitDateTime
      name="plannedDeliveryAt"
      :label="$t('logisticsTask.createOrEdit.plannedDeliveryAt.label')"
      :disabled="isLogisticsTaskPlanned"
      validation="required"
    />
    <FormKitMultiSelect
      name="customerId"
      :label="$t('logisticsTask.createOrEdit.customer.label')"
      :multi-select-options="customerOptions"
      :is-multi-select-allowed="false"
    />
    <FormKit
      name="workshopOfferId"
      :label="$t('logisticsTask.createOrEdit.workshopOffer.label')"
      type="text"
      validation="required"
    />
    <FormKit
      name="remarks"
      :label="$t('logisticsTask.createOrEdit.remarks.label')"
      :placeholder="$t('logisticsTask.createOrEdit.remarks.placeholder')"
      type="textarea"
      validation="required"
    />
  </FormKit>
</template>
